import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBoxOpen,
    faMinus,
    faXmark,
    faCirclePlus,
    faCircleXmark,
    faArrowDown,
    faLocation,
    faCalendar,
    faTableList,
    faKey,
    faUser,
    faImage,
    faTrash,
    faEnvelope,
    faUserPlus,
    faEllipsisVertical,
    faGear,
    faRightFromBracket,
    faRightToBracket,
    faHouse,
    faComments,
    faCircleExclamation,
    faTriangleExclamation,
    faCheck,
    faCircleInfo,
    faPlus,
    faFilePen,
    faPen,
    faLock,
    faUserGear,
    faBars,
    faX,
    faAngleRight,
    faChartLine,
    faFlaskVial,
    faTicket,
    faMoneyBills,
    faCircleCheck,
    faCodeCompare,
    faStar as faStarSolid,
    faPhone,
    faMapLocation,
    faMagnifyingGlass,
    faRoute,
    faMapPin,
    faGripVertical,
    faFlagCheckered,
    faClock,
    faCar,
    faHotel,
    faBed,
    faCaretDown,
    faCaretUp,
    faPersonDigging,
    faMapLocationDot,
    faEye,
    faEyeSlash,
    faGripLines,
    faUpload,
    faCalendarPlus,
    faSave,
    faDownload,
    faArrowUp,
    faThumbsUp,
} from '@fortawesome/free-solid-svg-icons'

import { faPenToSquare, faStar } from '@fortawesome/free-regular-svg-icons'

export const ICONS = {
    ELLIPSIS: 'faEllipsisVertical',
    GEAR: 'faGear',
    PASSWORD: 'faLock',
    LOGIN: 'faRightToBracket',
    LOGOUT: 'faRightFromBracket',
    HOUSE: 'faHouse',
    COMMENTS: 'faComments',
    CHECK: 'faCheck',
    ALERT: 'faCircleExclamation',
    INFO: 'faCircleInfo',
    ERROR: 'faTriangleExclamation',
    PLUS: 'faPlus',
    FILE: 'faFilePen',
    ADMINS: 'faUserGear',
    MENU: 'faBars',
    CLOSE_MENU: 'faX',
    ADD_USER: 'faUserPlus',
    EMAIL: 'faEnvelope',
    TRASH: 'faTrash',
    IMAGE: 'faImage',
    USER: 'faUser',
    KEY: 'faKey',
    LIST: 'faTableList',
    LOCATION: 'faLocation',
    CALENDAR: 'faCalendar',
    ARROW_DOWN: 'faArrowDown',
    CIRCLE_PLUS: 'faCirclePlus',
    CIRCLE_XMARK: 'faCircleXmark',
    X_MARK: 'faXmark',
    MINUS: 'faMinus',
    BOX_OPEN: 'faBoxOpen',
    ANGLE_RIGHT: 'faAngleRight',
    CHART_LINE: 'faChartLine',
    TEST: 'faFlaskVial',
    TICKET: 'faTicket',
    MONEY_BILLS: 'faMoneyBills',
    EDIT: 'faPenToSquare',
    CIRCLE_CHECK: 'faCircleCheck',
    CODE_COMPARE: 'faCodeCompare',
    STAR: 'faStar',
    STAR_FILLED: 'faStarSolid',
    PHONE: 'faPhone',
    PEN: 'faPen',
    MAP_LOCATION: 'faMapLocation',
    MAGNIFYING_GLASS: 'faMagnifyingGlass',
    ROUTE: 'faRoute',
    MAP_PIN: 'faMapPin',
    GRIP_VERTICAL: 'faGripVertical',
    FLAG_CHECKERED: 'faFlagCheckered',
    CLOCK: 'faClock',
    CAR: 'faCar',
    HOTEL: 'faHotel',
    BED: 'faBed',
    CARET_DOWN: 'faCaretDown',
    CARET_UP: 'faCaretUp',
    ROAD_WORK: 'faPersonDigging',
    MAP_LOCATION_DOT: 'faMapLocationDot',
    SHOW_PASSWORD: 'faEye',
    HIDE_PASSWORD: 'faEyeSlash',
    GRIP_LINES: 'faGripLines',
    UPLOAD: 'faUpload',
    CALENDAR_PLUS: 'faCalendarPlus',
    SAVE: 'faSave',
    DOWNLOAD: 'faDownload',
    ARROW_UP: 'faArrowUp',
    THUMB_UP: 'faThumbsUp',
} as const

const icons = {
    faAngleRight,
    faEllipsisVertical,
    faGear,
    faRightFromBracket,
    faRightToBracket,
    faHouse,
    faComments,
    faCircleExclamation,
    faTriangleExclamation,
    faCircleInfo,
    faPlus,
    faFilePen,
    faLock,
    faUserGear,
    faBars,
    faX,
    faCheck,
    faUserPlus,
    faEnvelope,
    faTrash,
    faImage,
    faUser,
    faKey,
    faTableList,
    faLocation,
    faCalendar,
    faArrowDown,
    faCirclePlus,
    faCircleXmark,
    faXmark,
    faMinus,
    faBoxOpen,
    faChartLine,
    faFlaskVial,
    faTicket,
    faMoneyBills,
    faPenToSquare,
    faCircleCheck,
    faCodeCompare,
    faStar,
    faStarSolid,
    faPhone,
    faPen,
    faMapLocation,
    faMagnifyingGlass,
    faRoute,
    faMapPin,
    faGripVertical,
    faFlagCheckered,
    faClock,
    faCar,
    faHotel,
    faBed,
    faCaretDown,
    faCaretUp,
    faPersonDigging,
    faMapLocationDot,
    faEye,
    faEyeSlash,
    faGripLines,
    faUpload,
    faCalendarPlus,
    faSave,
    faDownload,
    faArrowUp,
    faThumbsUp,
}

export type IconName = (typeof ICONS)[keyof typeof ICONS]

export function Icon({ name, ...props }: { name: IconName; [key: string]: any }) {
    const icon = icons[name]
    return (
        <FontAwesomeIcon
            icon={icon ?? faCircleExclamation}
            {...props}
        />
    )
}
